import React from "react";
import { cleanJoin } from "../../utils/stringUtil";
import "./UploadButton.scss";

function UploadIcon({
  label = "",
  acceptDocumentTypes = "",
  onChange,
  requests,
  className = "",
  inputName = "file",
}) {
  return (
    <div
      className={cleanJoin(
        "button",
        "is-inline-flex",
        "is-align-content-flex-end",
        "is-justify-content-flex-end",
        "p-0",
        "upload-icon",
        className
      )}
    >
      <div className={cleanJoin("file", "is-small", "is-white")}>
        <label>
          <input
            accept={acceptDocumentTypes}
            className={`file-input is-clickable`}
            type="file"
            name={inputName}
            requests={requests}
            onChange={onChange}
          />
          <div className="file-label is-size-6 has-text-grey-darker">{label}</div>
        </label>
      </div>
    </div>
  );
}

export default UploadIcon;
